import React from "react";
import { PhoneIcon, ArrowRightIcon } from "lucide-react";
import { ButtonLink } from "../shared/Button";
import { RooflineDivider } from "../shared/RooflineDivider";
import { Reveal } from "../shared/Reveal";

// [Conversion] Mid-page action point after proof. Centred, symmetrical.
export function CtaBand() {
  return <section aria-labelledby="cta-band-heading" className="bg-paper py-16 md:py-20" data-id="element-197" data-mp="2s658m5x4juqa">
      <div className="mx-auto max-w-site px-5 md:px-10" data-id="element-198" data-mp="24gawjqkmqa73">
        <Reveal className="rounded-[32px] border border-line bg-white px-6 py-12 text-center md:px-16 md:py-16" data-id="element-199" data-mp="24h2qkwykvzv9">
          <RooflineDivider className="mx-auto max-w-md text-line" data-id="element-200" data-mp="2ed5vgakteclw" />
          <h2 id="cta-band-heading" className="mx-auto mt-8 max-w-2xl text-[28px] font-semibold leading-tight tracking-tight md:text-[40px]" data-id="element-201" data-mp="2ebck4hz9b47k">
            Talk directly with the owners about your next home.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[17px] leading-relaxed text-slate" data-id="element-202" data-mp="3kthuedvgnyij">
            No sales team and no scripts. Just an honest conversation about your plans, your block and what comes next.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-203" data-mp="30k7dtef4l6uw">
            <ButtonLink to="/contact" data-id="element-204" data-mp="35jabgdss0asu">
              Book a consultation <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-205" data-mp="35hpfcjqtcjsv" />
            </ButtonLink>
            <a href="tel:+61862850876" className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full border-[1.5px] border-charcoal px-7 text-[16px] font-semibold text-charcoal transition-colors duration-150 ease-out hover:bg-charcoal hover:text-paper" data-id="element-206" data-mp="39km12jbngw11">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="2ltzu6vddthsm" /> 08 6285 0876
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}